// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 메인 컨테이너 */
.admin-content-form {
    flex-grow: 1;
    padding: 20px;
    background-color: #fff;
}

/* 페이지 헤더 */
.page-header {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 30px;
}

.page-title-bar {
    width: 5px;
    height: 24px;
    background-color: #e84118;
}

.admin-content-form h2 {
    font-size: 24px;
    margin: 0;
    color: #333;
    font-weight: bold;
}

/* 폼 섹션 */
.form-section {
    margin-bottom: 50px;
}

.section-header {
    margin-bottom: 20px;
}

.section-title {
    font-size: 18px;
    font-weight: bold;
    color: #333;
    margin: 0 0 10px 0;
}

.section-divider {
    border: none;
    border-top: 2px solid #ddd;
    margin: 0;
}

/* 정보 테이블 */
.info-table {
    width: 100%;
    border-collapse: collapse;
    border: 1px solid #ddd;
    margin-top: 1px;
}

.info-table th,
.info-table td {
    border: 1px solid #ddd;
    padding: 15px 20px;
    text-align: left;
    vertical-align: top;
}

.info-table th {
    background-color: #f8f9fa;
    font-weight: bold;
    width: 200px;
    color: #333;
    font-size: 14px;
}

.info-table td {
    background-color: #fff;
}

/* 폼 입력 요소 */
.form-input {
    width: 400px;
    padding: 8px 12px;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 14px;
    color: #666;
}

.form-input:focus {
    outline: none;
    border-color: #007bff;
    box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
}

/* 카테고리 선택 */
.category-selectors {
    display: flex;
    align-items: center;
    gap: 15px;
}

.category-select {
    width: 200px;
    padding: 8px 12px;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 14px;
    background-color: #fff;
}

.category-select:disabled {
    background-color: #f5f5f5;
    color: #999;
}

.arrow {
    font-size: 16px;
    color: #666;
    font-weight: bold;
}

/* 옵션 관리 */
.options-container {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.option-row {
    display: flex;
    align-items: center;
    gap: 10px;
}

.option-input {
    flex: 1 1;
    max-width: 300px;
    padding: 8px 12px;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 14px;
}

.option-input:disabled {
    background-color: #f5f5f5;
    color: #999;
}

.btn-remove-option {
    padding: 6px 12px;
    background-color: #dc3545;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 12px;
    transition: background-color 0.2s;
}

.btn-remove-option:hover {
    background-color: #c82333;
}

.btn-add-option {
    padding: 8px 16px;
    background-color: #e84118;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    margin-top: 5px;
    align-self: flex-start;
    transition: background-color 0.2s;
}

.btn-add-option:hover {
    background-color: #d63031;
}

/* 파일 업로드 섹션 */
.file-upload-section {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.file-input {
    display: none;
}

.file-upload-btn {
    padding: 8px 16px;
    background-color: #6c757d;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    transition: background-color 0.2s;
}

.file-upload-btn:hover {
    background-color: #545b62;
}

.file-upload-btn:disabled {
    background-color: #ccc;
    cursor: not-allowed;
}

.file-info {
    font-size: 14px;
    color: #666;
    margin-left: 10px;
}

/* 업로드 성공 표시 */
.upload-success {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-top: 8px;
}

.success-text {
    color: #28a745;
    font-weight: bold;
    font-size: 14px;
}

.s3-link {
    color: #007bff;
    text-decoration: none;
    font-size: 12px;
    transition: color 0.2s;
}

.s3-link:hover {
    color: #0056b3;
    text-decoration: underline;
}

.btn-remove-file {
    padding: 2px 8px;
    background-color: #dc3545;
    color: white;
    border: none;
    border-radius: 3px;
    cursor: pointer;
    font-size: 11px;
    transition: background-color 0.2s;
}

.btn-remove-file:hover {
    background-color: #c82333;
}

/* 이미지 미리보기 */
.image-preview-container {
    margin-top: 10px;
}

.image-preview-wrapper {
    position: relative;
    width: 80px;
    height: 80px;
    border: 1px solid #ddd;
    border-radius: 4px;
    overflow: hidden;
    cursor: pointer;
}

.image-preview {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.2s;
}

.image-preview:hover {
    transform: scale(1.05);
}

/* 업로드 오버레이 및 스피너 */
.upload-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(255, 255, 255, 0.8);
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
}

.spinner {
    border: 3px solid #f3f3f3;
    border-top: 3px solid #007bff;
    border-radius: 50%;
    width: 20px;
    height: 20px;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}

/* 에디터 컨테이너 */
.editor-container {
    border: 1px solid #ddd;
    border-radius: 4px;
    overflow: hidden;
}

.editor-toolbar {
    display: flex;
    gap: 2px;
    padding: 8px;
    background-color: #f8f9fa;
    border-bottom: 1px solid #ddd;
}

.editor-btn {
    padding: 6px 10px;
    background-color: #fff;
    border: 1px solid #ccc;
    border-radius: 3px;
    cursor: pointer;
    font-size: 12px;
    color: #333;
    transition: background-color 0.2s;
}

.editor-btn:hover {
    background-color: #e9ecef;
}

.editor-textarea {
    width: 100%;
    min-height: 200px;
    padding: 15px;
    border: none;
    resize: vertical;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    font-size: 14px;
    line-height: 1.5;
    outline: none;
}

.editor-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 15px;
    background-color: #f8f9fa;
    border-top: 1px solid #ddd;
    font-size: 12px;
    color: #666;
}

.editor-actions {
    display: flex;
    gap: 5px;
}

.btn-editor-action {
    padding: 4px 8px;
    background-color: #6c757d;
    color: white;
    border: none;
    border-radius: 3px;
    cursor: pointer;
    font-size: 11px;
    transition: background-color 0.2s;
}

.btn-editor-action:hover {
    background-color: #545b62;
}

/* 폼 액션 버튼 */
.form-actions {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 20px;
    margin-top: 40px;
    padding-top: 20px;
    border-top: 1px solid #ddd;
}

.btn-back {
    padding: 15px 30px;
    background-color: #6c757d;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    font-size: 16px;
    transition: all 0.2s;
    display: flex;
    align-items: center;
    gap: 8px;
    min-width: 150px;
    justify-content: center;
}

.btn-back:hover {
    background-color: #545b62;
    transform: translateY(-1px);
    box-shadow: 0 2px 4px rgba(0,0,0,0.2);
}

.btn-save {
    padding: 15px 30px;
    background-color: #e84118;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    font-size: 16px;
    font-weight: bold;
    transition: all 0.2s;
    display: flex;
    align-items: center;
    gap: 8px;
    min-width: 150px;
    justify-content: center;
}

.btn-save:hover {
    background-color: #d63031;
    transform: translateY(-1px);
    box-shadow: 0 2px 4px rgba(232, 65, 24, 0.3);
}

.btn-save:disabled {
    background-color: #ccc;
    cursor: not-allowed;
    transform: none;
    box-shadow: none;
}

.arrow-icon {
    font-size: 14px;
    font-weight: bold;
    line-height: 1;
}

/* 반응형 디자인 */
@media (max-width: 768px) {
    .admin-content-form {
        padding: 15px;
    }
    
    .info-table th,
    .info-table td {
        padding: 10px;
    }
    
    .info-table th {
        width: 120px;
    }
    
    .form-input {
        width: 100%;
        max-width: 300px;
    }
    
    .category-selectors {
        flex-direction: column;
        align-items: flex-start;
        gap: 10px;
    }
    
    .category-select {
        width: 100%;
        max-width: 250px;
    }
    
    .option-row {
        flex-direction: column;
        align-items: flex-start;
        gap: 8px;
    }
    
    .option-input {
        width: 100%;
        max-width: 250px;
    }
    
    .form-actions {
        flex-direction: row;
        gap: 15px;
        justify-content: center;
    }
    
    .btn-back,
    .btn-save {
        flex: 1 1;
        max-width: 150px;
        min-width: 120px;
    }
    
    .upload-success {
        flex-direction: column;
        align-items: flex-start;
        gap: 5px;
    }
    
    .image-preview-wrapper {
        width: 60px;
        height: 60px;
    }
}

/* 파일 드래그 앤 드롭 스타일 (향후 추가 예정) */
.file-drop-zone {
    border: 2px dashed #ccc;
    border-radius: 4px;
    padding: 20px;
    text-align: center;
    color: #666;
    transition: border-color 0.3s;
}

.file-drop-zone.active {
    border-color: #007bff;
    background-color: #f8f9ff;
}

/* 추가 스타일 - 파일 업로드 첫 번째 행 정렬 */
.file-upload-section > div:first-child {
    display: flex;
    align-items: center;
    gap: 10px;
}

/* 업로드 상태 애니메이션 */
.file-upload-btn:disabled {
    opacity: 0.6;
}

/* 성공/에러 상태 색상 */
.upload-error {
    color: #dc3545;
    font-size: 12px;
    margin-top: 5px;
}

.upload-progress {
    color: #007bff;
    font-size: 12px;
    margin-top: 5px;
}

/* 파일 목록 스타일 */
.file-list {
    margin-top: 15px;
    padding: 15px;
    background-color: #f8f9fa;
    border-radius: 6px;
    border: 1px solid #e9ecef;
    max-height: 300px;
    overflow-y: auto;
}

.file-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 0;
    border-bottom: 1px solid #e9ecef;
}

.file-item:last-child {
    border-bottom: none;
}

.file-details {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    gap: 4px;
}

.file-name {
    font-size: 14px;
    color: #333;
    font-weight: 500;
    word-break: break-all;
}

.file-size {
    font-size: 12px;
    color: #666;
}

.file-actions {
    display: flex;
    gap: 8px;
    align-items: center;
}

.btn-file-action {
    padding: 6px 12px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 12px;
    font-weight: 500;
    transition: all 0.2s;
    text-decoration: none;
    display: inline-flex;
    align-items: center;
    gap: 4px;
}

.btn-file-action.preview {
    background-color: #007bff;
    color: white;
}

.btn-file-action.preview:hover {
    background-color: #0056b3;
    transform: translateY(-1px);
}

.btn-file-action.download {
    background-color: #28a745;
    color: white;
}

.btn-file-action.download:hover {
    background-color: #1e7e34;
    transform: translateY(-1px);
}

/* 호버 효과 개선 */
.file-upload-btn:not(:disabled):hover {
    transform: translateY(-1px);
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.btn-remove-file:hover {
    transform: translateY(-1px);
}

/* 포커스 스타일 */
.file-upload-btn:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(108, 117, 125, 0.25);
}

/* 로딩 상태 텍스트 */
.uploading-text {
    color: #007bff;
    font-style: italic;
    font-size: 12px;
} `, "",{"version":3,"sources":["webpack://./src/admin/css/ProductFormPage.css"],"names":[],"mappings":"AAAA,YAAY;AACZ;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;AAC1B;;AAEA,WAAW;AACX;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,SAAS;IACT,WAAW;IACX,iBAAiB;AACrB;;AAEA,SAAS;AACT;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,0BAA0B;IAC1B,SAAS;AACb;;AAEA,WAAW;AACX;IACI,WAAW;IACX,yBAAyB;IACzB,sBAAsB;IACtB,eAAe;AACnB;;AAEA;;IAEI,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,YAAY;IACZ,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA,YAAY;AACZ;IACI,YAAY;IACZ,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,6CAA6C;AACjD;;AAEA,YAAY;AACZ;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,WAAW;IACX,iBAAiB;AACrB;;AAEA,UAAU;AACV;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,SAAO;IACP,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,eAAe;IACf,sBAAsB;IACtB,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,cAAc;AACd;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,iBAAiB;AACrB;;AAEA,cAAc;AACd;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,aAAa;AACb;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,0BAA0B;AAC9B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA,mBAAmB;AACnB;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,0CAA0C;IAC1C,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,6BAA6B;IAC7B,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kCAAkC;AACtC;;AAEA;IACI,KAAK,uBAAuB,EAAE;IAC9B,OAAO,yBAAyB,EAAE;AACtC;;AAEA,aAAa;AACb;IACI,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,YAAY;IACZ,yBAAyB;IACzB,6BAA6B;AACjC;;AAEA;IACI,iBAAiB;IACjB,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,WAAW;IACX,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,aAAa;IACb,YAAY;IACZ,gBAAgB;IAChB,4DAA4D;IAC5D,eAAe;IACf,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,iBAAiB;IACjB,yBAAyB;IACzB,0BAA0B;IAC1B,eAAe;IACf,WAAW;AACf;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,YAAY;AACZ;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,gBAAgB;IAChB,iBAAiB;IACjB,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,oBAAoB;IACpB,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;IAC3B,qCAAqC;AACzC;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,oBAAoB;IACpB,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;IAC3B,4CAA4C;AAChD;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA,YAAY;AACZ;IACI;QACI,aAAa;IACjB;;IAEA;;QAEI,aAAa;IACjB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,gBAAgB;IACpB;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;QACvB,SAAS;IACb;;IAEA;QACI,WAAW;QACX,gBAAgB;IACpB;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;QACvB,QAAQ;IACZ;;IAEA;QACI,WAAW;QACX,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;QACnB,SAAS;QACT,uBAAuB;IAC3B;;IAEA;;QAEI,SAAO;QACP,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;QACvB,QAAQ;IACZ;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;AACJ;;AAEA,+BAA+B;AAC/B;IACI,uBAAuB;IACvB,kBAAkB;IAClB,aAAa;IACb,kBAAkB;IAClB,WAAW;IACX,6BAA6B;AACjC;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA,8BAA8B;AAC9B;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA,iBAAiB;AACjB;IACI,YAAY;AAChB;;AAEA,gBAAgB;AAChB;IACI,cAAc;IACd,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,eAAe;AACnB;;AAEA,cAAc;AACd;IACI,gBAAgB;IAChB,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,yBAAyB;IACzB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,qBAAqB;IACrB,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA,aAAa;AACb;IACI,2BAA2B;IAC3B,qCAAqC;AACzC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA,YAAY;AACZ;IACI,aAAa;IACb,+CAA+C;AACnD;;AAEA,cAAc;AACd;IACI,cAAc;IACd,kBAAkB;IAClB,eAAe;AACnB","sourcesContent":["/* 메인 컨테이너 */\n.admin-content-form {\n    flex-grow: 1;\n    padding: 20px;\n    background-color: #fff;\n}\n\n/* 페이지 헤더 */\n.page-header {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    margin-bottom: 30px;\n}\n\n.page-title-bar {\n    width: 5px;\n    height: 24px;\n    background-color: #e84118;\n}\n\n.admin-content-form h2 {\n    font-size: 24px;\n    margin: 0;\n    color: #333;\n    font-weight: bold;\n}\n\n/* 폼 섹션 */\n.form-section {\n    margin-bottom: 50px;\n}\n\n.section-header {\n    margin-bottom: 20px;\n}\n\n.section-title {\n    font-size: 18px;\n    font-weight: bold;\n    color: #333;\n    margin: 0 0 10px 0;\n}\n\n.section-divider {\n    border: none;\n    border-top: 2px solid #ddd;\n    margin: 0;\n}\n\n/* 정보 테이블 */\n.info-table {\n    width: 100%;\n    border-collapse: collapse;\n    border: 1px solid #ddd;\n    margin-top: 1px;\n}\n\n.info-table th,\n.info-table td {\n    border: 1px solid #ddd;\n    padding: 15px 20px;\n    text-align: left;\n    vertical-align: top;\n}\n\n.info-table th {\n    background-color: #f8f9fa;\n    font-weight: bold;\n    width: 200px;\n    color: #333;\n    font-size: 14px;\n}\n\n.info-table td {\n    background-color: #fff;\n}\n\n/* 폼 입력 요소 */\n.form-input {\n    width: 400px;\n    padding: 8px 12px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    font-size: 14px;\n    color: #666;\n}\n\n.form-input:focus {\n    outline: none;\n    border-color: #007bff;\n    box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);\n}\n\n/* 카테고리 선택 */\n.category-selectors {\n    display: flex;\n    align-items: center;\n    gap: 15px;\n}\n\n.category-select {\n    width: 200px;\n    padding: 8px 12px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    font-size: 14px;\n    background-color: #fff;\n}\n\n.category-select:disabled {\n    background-color: #f5f5f5;\n    color: #999;\n}\n\n.arrow {\n    font-size: 16px;\n    color: #666;\n    font-weight: bold;\n}\n\n/* 옵션 관리 */\n.options-container {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n}\n\n.option-row {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.option-input {\n    flex: 1;\n    max-width: 300px;\n    padding: 8px 12px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    font-size: 14px;\n}\n\n.option-input:disabled {\n    background-color: #f5f5f5;\n    color: #999;\n}\n\n.btn-remove-option {\n    padding: 6px 12px;\n    background-color: #dc3545;\n    color: white;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 12px;\n    transition: background-color 0.2s;\n}\n\n.btn-remove-option:hover {\n    background-color: #c82333;\n}\n\n.btn-add-option {\n    padding: 8px 16px;\n    background-color: #e84118;\n    color: white;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 14px;\n    margin-top: 5px;\n    align-self: flex-start;\n    transition: background-color 0.2s;\n}\n\n.btn-add-option:hover {\n    background-color: #d63031;\n}\n\n/* 파일 업로드 섹션 */\n.file-upload-section {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n}\n\n.file-input {\n    display: none;\n}\n\n.file-upload-btn {\n    padding: 8px 16px;\n    background-color: #6c757d;\n    color: white;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 14px;\n    transition: background-color 0.2s;\n}\n\n.file-upload-btn:hover {\n    background-color: #545b62;\n}\n\n.file-upload-btn:disabled {\n    background-color: #ccc;\n    cursor: not-allowed;\n}\n\n.file-info {\n    font-size: 14px;\n    color: #666;\n    margin-left: 10px;\n}\n\n/* 업로드 성공 표시 */\n.upload-success {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    margin-top: 8px;\n}\n\n.success-text {\n    color: #28a745;\n    font-weight: bold;\n    font-size: 14px;\n}\n\n.s3-link {\n    color: #007bff;\n    text-decoration: none;\n    font-size: 12px;\n    transition: color 0.2s;\n}\n\n.s3-link:hover {\n    color: #0056b3;\n    text-decoration: underline;\n}\n\n.btn-remove-file {\n    padding: 2px 8px;\n    background-color: #dc3545;\n    color: white;\n    border: none;\n    border-radius: 3px;\n    cursor: pointer;\n    font-size: 11px;\n    transition: background-color 0.2s;\n}\n\n.btn-remove-file:hover {\n    background-color: #c82333;\n}\n\n/* 이미지 미리보기 */\n.image-preview-container {\n    margin-top: 10px;\n}\n\n.image-preview-wrapper {\n    position: relative;\n    width: 80px;\n    height: 80px;\n    border: 1px solid #ddd;\n    border-radius: 4px;\n    overflow: hidden;\n    cursor: pointer;\n}\n\n.image-preview {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    transition: transform 0.2s;\n}\n\n.image-preview:hover {\n    transform: scale(1.05);\n}\n\n/* 업로드 오버레이 및 스피너 */\n.upload-overlay {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(255, 255, 255, 0.8);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 4px;\n}\n\n.spinner {\n    border: 3px solid #f3f3f3;\n    border-top: 3px solid #007bff;\n    border-radius: 50%;\n    width: 20px;\n    height: 20px;\n    animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n    0% { transform: rotate(0deg); }\n    100% { transform: rotate(360deg); }\n}\n\n/* 에디터 컨테이너 */\n.editor-container {\n    border: 1px solid #ddd;\n    border-radius: 4px;\n    overflow: hidden;\n}\n\n.editor-toolbar {\n    display: flex;\n    gap: 2px;\n    padding: 8px;\n    background-color: #f8f9fa;\n    border-bottom: 1px solid #ddd;\n}\n\n.editor-btn {\n    padding: 6px 10px;\n    background-color: #fff;\n    border: 1px solid #ccc;\n    border-radius: 3px;\n    cursor: pointer;\n    font-size: 12px;\n    color: #333;\n    transition: background-color 0.2s;\n}\n\n.editor-btn:hover {\n    background-color: #e9ecef;\n}\n\n.editor-textarea {\n    width: 100%;\n    min-height: 200px;\n    padding: 15px;\n    border: none;\n    resize: vertical;\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n    font-size: 14px;\n    line-height: 1.5;\n    outline: none;\n}\n\n.editor-footer {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 8px 15px;\n    background-color: #f8f9fa;\n    border-top: 1px solid #ddd;\n    font-size: 12px;\n    color: #666;\n}\n\n.editor-actions {\n    display: flex;\n    gap: 5px;\n}\n\n.btn-editor-action {\n    padding: 4px 8px;\n    background-color: #6c757d;\n    color: white;\n    border: none;\n    border-radius: 3px;\n    cursor: pointer;\n    font-size: 11px;\n    transition: background-color 0.2s;\n}\n\n.btn-editor-action:hover {\n    background-color: #545b62;\n}\n\n/* 폼 액션 버튼 */\n.form-actions {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 20px;\n    margin-top: 40px;\n    padding-top: 20px;\n    border-top: 1px solid #ddd;\n}\n\n.btn-back {\n    padding: 15px 30px;\n    background-color: #6c757d;\n    color: white;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n    font-size: 16px;\n    transition: all 0.2s;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    min-width: 150px;\n    justify-content: center;\n}\n\n.btn-back:hover {\n    background-color: #545b62;\n    transform: translateY(-1px);\n    box-shadow: 0 2px 4px rgba(0,0,0,0.2);\n}\n\n.btn-save {\n    padding: 15px 30px;\n    background-color: #e84118;\n    color: white;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n    font-size: 16px;\n    font-weight: bold;\n    transition: all 0.2s;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    min-width: 150px;\n    justify-content: center;\n}\n\n.btn-save:hover {\n    background-color: #d63031;\n    transform: translateY(-1px);\n    box-shadow: 0 2px 4px rgba(232, 65, 24, 0.3);\n}\n\n.btn-save:disabled {\n    background-color: #ccc;\n    cursor: not-allowed;\n    transform: none;\n    box-shadow: none;\n}\n\n.arrow-icon {\n    font-size: 14px;\n    font-weight: bold;\n    line-height: 1;\n}\n\n/* 반응형 디자인 */\n@media (max-width: 768px) {\n    .admin-content-form {\n        padding: 15px;\n    }\n    \n    .info-table th,\n    .info-table td {\n        padding: 10px;\n    }\n    \n    .info-table th {\n        width: 120px;\n    }\n    \n    .form-input {\n        width: 100%;\n        max-width: 300px;\n    }\n    \n    .category-selectors {\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 10px;\n    }\n    \n    .category-select {\n        width: 100%;\n        max-width: 250px;\n    }\n    \n    .option-row {\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 8px;\n    }\n    \n    .option-input {\n        width: 100%;\n        max-width: 250px;\n    }\n    \n    .form-actions {\n        flex-direction: row;\n        gap: 15px;\n        justify-content: center;\n    }\n    \n    .btn-back,\n    .btn-save {\n        flex: 1;\n        max-width: 150px;\n        min-width: 120px;\n    }\n    \n    .upload-success {\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 5px;\n    }\n    \n    .image-preview-wrapper {\n        width: 60px;\n        height: 60px;\n    }\n}\n\n/* 파일 드래그 앤 드롭 스타일 (향후 추가 예정) */\n.file-drop-zone {\n    border: 2px dashed #ccc;\n    border-radius: 4px;\n    padding: 20px;\n    text-align: center;\n    color: #666;\n    transition: border-color 0.3s;\n}\n\n.file-drop-zone.active {\n    border-color: #007bff;\n    background-color: #f8f9ff;\n}\n\n/* 추가 스타일 - 파일 업로드 첫 번째 행 정렬 */\n.file-upload-section > div:first-child {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n/* 업로드 상태 애니메이션 */\n.file-upload-btn:disabled {\n    opacity: 0.6;\n}\n\n/* 성공/에러 상태 색상 */\n.upload-error {\n    color: #dc3545;\n    font-size: 12px;\n    margin-top: 5px;\n}\n\n.upload-progress {\n    color: #007bff;\n    font-size: 12px;\n    margin-top: 5px;\n}\n\n/* 파일 목록 스타일 */\n.file-list {\n    margin-top: 15px;\n    padding: 15px;\n    background-color: #f8f9fa;\n    border-radius: 6px;\n    border: 1px solid #e9ecef;\n    max-height: 300px;\n    overflow-y: auto;\n}\n\n.file-item {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 12px 0;\n    border-bottom: 1px solid #e9ecef;\n}\n\n.file-item:last-child {\n    border-bottom: none;\n}\n\n.file-details {\n    display: flex;\n    flex-direction: column;\n    flex-grow: 1;\n    gap: 4px;\n}\n\n.file-name {\n    font-size: 14px;\n    color: #333;\n    font-weight: 500;\n    word-break: break-all;\n}\n\n.file-size {\n    font-size: 12px;\n    color: #666;\n}\n\n.file-actions {\n    display: flex;\n    gap: 8px;\n    align-items: center;\n}\n\n.btn-file-action {\n    padding: 6px 12px;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 12px;\n    font-weight: 500;\n    transition: all 0.2s;\n    text-decoration: none;\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n}\n\n.btn-file-action.preview {\n    background-color: #007bff;\n    color: white;\n}\n\n.btn-file-action.preview:hover {\n    background-color: #0056b3;\n    transform: translateY(-1px);\n}\n\n.btn-file-action.download {\n    background-color: #28a745;\n    color: white;\n}\n\n.btn-file-action.download:hover {\n    background-color: #1e7e34;\n    transform: translateY(-1px);\n}\n\n/* 호버 효과 개선 */\n.file-upload-btn:not(:disabled):hover {\n    transform: translateY(-1px);\n    box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n}\n\n.btn-remove-file:hover {\n    transform: translateY(-1px);\n}\n\n/* 포커스 스타일 */\n.file-upload-btn:focus {\n    outline: none;\n    box-shadow: 0 0 0 2px rgba(108, 117, 125, 0.25);\n}\n\n/* 로딩 상태 텍스트 */\n.uploading-text {\n    color: #007bff;\n    font-style: italic;\n    font-size: 12px;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
